// extracted by mini-css-extract-plugin
export default {"detailsWrapper":"cookieDetails_detailsWrapper","details":"cookieDetails_details","row":"cookieDetails_row","title":"cookieDetails_title","info":"cookieDetails_info"};